import React, { useRef } from 'react';
import { Wrapper, Fields } from './styled';
import ActionBar from './components/ActionBar';
import Description from './components/Description';
import Resolution from './components/Resolution';
import References from './components/References';
import ImpactsTab from './components/ImpactsTab';
import ExternalId from './components/ExternalId';
import Policies from './components/Policies';
import RiskInformation from './components/RiskInformation';
import { useAutoScrollOnHeightIncrease } from 'Hooks/useAutoScrollOnHeightIncrease';

const GeneralTab = () => {
  const wrapperRef = useRef(null);
  useAutoScrollOnHeightIncrease(wrapperRef);

  return (
    <Wrapper >
    <Fields ref={ wrapperRef }>
      <ActionBar />
      <Description />
      <Resolution />
      <References />
      <ImpactsTab />
      <ExternalId />
      <Policies />
      <RiskInformation />
    </Fields>
    </Wrapper>
  );
};

export default GeneralTab;
